<template>
  <div class="WechatUsers app-container">
    <el-card class="box-card">
      <el-form
        :inline="true"
        class="demo-form-inline"
      >
        <el-form-item label="任务ID">
          <el-input
            v-model="reportQuery.task_id"
            placeholder="请输入内容"
          />
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select
            v-model="reportQuery.type"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in reportSelectList.type_list"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="任务状态">
          <el-select
            v-model="reportQuery.status"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in reportSelectList.status_list"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="search"
          >查询</el-button>
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="reset"
          >重置</el-button>
        </el-form-item>
      </el-form>
      <main>
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="任务ID"
            min-width="90"
          />
          <el-table-column
            prop="type_str"
            label="任务类型"
            min-width="90"
          />
          <el-table-column
            prop="factor"
            label="查询条件"
            min-width="550"
          />
          <el-table-column
            prop="created_at"
            label="创建时间"
            min-width="400"
          />
          <el-table-column
            prop="status_str"
            label="任务状态"
            min-width="80"
          />
          <el-table-column
            prop="date"
            label="操作"
            min-width="80"
            align="center"
          >
            <template scope="scope">
              <a
                :href="scope.row.url"
                :style="scope.row.url === null ? 'pointer-events: none; color: #ccc;' : 'color: 	#409EFF'"
              >下载</a>
            </template>
          </el-table-column>
        </el-table>
      </main>
      <pagination-right
        :total="total"
        :page-sizes="[20]"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getList, reportSelect } from '@/api/report/exportLog.js'

export default {
  name: 'ExportLog',
  components: {
    PaginationRight
  },
  data() {
    return {
      reportSelectList: [], // 平台筛选列表
      reportQuery: {
        task_id: null,
        type: null,
        status: null,
        page: 1,
        page_size: 10
      },
      tableData: null, // 表格数据
      loading: false, // 加载效果
      total: null
    }
  },
  created() {
    this.getListData()
    this.getReportSelect()
  },
  methods: {
    // 获取列表数据
    getListData() {
      this.loading = true
      getList(this.reportQuery).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
      })
    },
    // 获取筛选列表
    getReportSelect() {
      this.loading = true
      reportSelect().then(res => {
        this.reportSelectList = res.data
        this.loading = false
      })
    },
    // 重置请求数据
    resetData() {
      this.reportQuery = {
        task_id: null,
        type: null,
        status: null,
        page: 1,
        page_size: 10
      }
    },
    // 分页
    fetchPageSize(e) {
      this.reportQuery.page_size = e
      this.getListData()
    },
    fetchCurrentPage(e) {
      this.reportQuery.page = e
      this.getListData()
    },
    // 搜索数据
    search() {
      this.reportQuery.page = 1
      this.getListData()
    },
    // 重置搜索框
    reset() {
      this.resetData()
      this.getListData()
    }
  }
}
</script>

<style scoped lang="less">
.WechatUsers {
  min-width: 1200px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
